/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ProcessingStatusType } from './ProcessingStatusType.js';
import {
    ProcessingStatusTypeFromJSON,
    ProcessingStatusTypeFromJSONTyped,
    ProcessingStatusTypeToJSON,
} from './ProcessingStatusType.js';
import type { Utterance } from './Utterance.js';
import {
    UtteranceFromJSON,
    UtteranceFromJSONTyped,
    UtteranceToJSON,
} from './Utterance.js';

/**
 * 
 * @export
 * @interface ContactWithUtterances
 */
export interface ContactWithUtterances {
    /**
     * 
     * @type {number}
     * @memberof ContactWithUtterances
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactWithUtterances
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactWithUtterances
     */
    customerPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactWithUtterances
     */
    systemPhoneNumber?: string;
    /**
     * 
     * @type {ProcessingStatusType}
     * @memberof ContactWithUtterances
     */
    processingStatus?: ProcessingStatusType;
    /**
     * 
     * @type {string}
     * @memberof ContactWithUtterances
     */
    agentName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactWithUtterances
     */
    audioUri?: string;
    /**
     * 
     * @type {number}
     * @memberof ContactWithUtterances
     */
    agentUserId?: number;
    /**
     * 
     * @type {Date}
     * @memberof ContactWithUtterances
     */
    dateStarted?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContactWithUtterances
     */
    dateEnded?: Date;
    /**
     * 
     * @type {Array<Utterance>}
     * @memberof ContactWithUtterances
     */
    utterances?: Array<Utterance>;
}

/**
 * Check if a given object implements the ContactWithUtterances interface.
 */
export function instanceOfContactWithUtterances(value: object): boolean {
    return true;
}

export function ContactWithUtterancesFromJSON(json: any): ContactWithUtterances {
    return ContactWithUtterancesFromJSONTyped(json, false);
}

export function ContactWithUtterancesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactWithUtterances {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'customerPhoneNumber': json['customerPhoneNumber'] == null ? undefined : json['customerPhoneNumber'],
        'systemPhoneNumber': json['systemPhoneNumber'] == null ? undefined : json['systemPhoneNumber'],
        'processingStatus': json['processingStatus'] == null ? undefined : ProcessingStatusTypeFromJSON(json['processingStatus']),
        'agentName': json['agentName'] == null ? undefined : json['agentName'],
        'audioUri': json['audioUri'] == null ? undefined : json['audioUri'],
        'agentUserId': json['agentUserId'] == null ? undefined : json['agentUserId'],
        'dateStarted': json['dateStarted'] == null ? undefined : (new Date(json['dateStarted'])),
        'dateEnded': json['dateEnded'] == null ? undefined : (new Date(json['dateEnded'])),
        'utterances': json['utterances'] == null ? undefined : ((json['utterances'] as Array<any>).map(UtteranceFromJSON)),
    };
}

export function ContactWithUtterancesToJSON(value?: ContactWithUtterances | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'sourceId': value['sourceId'],
        'customerPhoneNumber': value['customerPhoneNumber'],
        'systemPhoneNumber': value['systemPhoneNumber'],
        'processingStatus': ProcessingStatusTypeToJSON(value['processingStatus']),
        'agentName': value['agentName'],
        'audioUri': value['audioUri'],
        'agentUserId': value['agentUserId'],
        'dateStarted': value['dateStarted'] == null ? undefined : ((value['dateStarted']).toISOString()),
        'dateEnded': value['dateEnded'] == null ? undefined : ((value['dateEnded']).toISOString()),
        'utterances': value['utterances'] == null ? undefined : ((value['utterances'] as Array<any>).map(UtteranceToJSON)),
    };
}

